import { Separator } from '@zep-us/zus';
import { UserAvatar } from '@/shared/features/user-avatar';
import { type QuizBankAuthor, type QuizBankStandard } from '../types';
import { QuizBankStandardCode } from './QuizBankStandardCode';
interface QuizBankProblemCardFooterProps {
  standard: QuizBankStandard;
  author: QuizBankAuthor;
  onStandardClick?: (standard: QuizBankStandard) => void;
}

/**
 * 카드 하단 메타 — 작성자 | 단원 | 성취기준.
 * 단원은 서버가 주는 값이고, 미이행 문항이면 없어서 생략한다. 영역명(수와 연산 등)은 보여주지 않는다 —
 * 단원명만으로 충분하고, 서버도 검색 응답에서 내리지 않는다.
 */
export const QuizBankProblemCardFooter = ({
  standard,
  author,
  onStandardClick
}: QuizBankProblemCardFooterProps) => {
  const unitName = standard.unitName;
  return <div className="flex w-full min-w-0 flex-wrap items-center gap-xs text-body-sm-medium text-neutral" data-sentry-component="QuizBankProblemCardFooter" data-sentry-source-file="QuizBankProblemCardFooter.tsx">
      <span className="flex min-w-0 items-center gap-3xs text-default">
        {/* avatarData 가 null 이면 UserAvatar 가 FallbackAvatar 를 그린다 */}
        <UserAvatar avatarData={author.avatarData} size="xxs" className="shrink-0" data-sentry-element="UserAvatar" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
        <span className="truncate">{author.name}</span>
      </span>

      {unitName && <>
          <Separator orientation="vertical" className="h-[12px] self-center bg-gray-300" />
          <span className="truncate">{unitName}</span>
        </>}

      <Separator orientation="vertical" className="h-[12px] self-center bg-gray-300" data-sentry-element="Separator" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />

      <QuizBankStandardCode code={standard.code} description={standard.description} onClick={() => onStandardClick?.(standard)} data-sentry-element="QuizBankStandardCode" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
    </div>;
};